
export class AuthError extends Error {
  constructor(message: string = 'Authentication required') {
    super(message);
    this.name = 'AuthError';
  }
}

export const isAuthError = (error: unknown): error is AuthError => {
  return error instanceof AuthError ||
         (error instanceof Error && 
          (error.message.includes('401') || error.message.includes('unauthorized')));
};
